import Dropdown from "../common/Dropdown";
import { useClient } from "../../context/ClientsProvider";
import { useNavigate } from "react-router-dom";

export default function ClientDropdown() {
  const {
    clients,
    selectedClient,
    shouldShowClientSelector,
    setSelectedClient,
    loading,
  } = useClient();
  const navigate = useNavigate();

  const handleSelect = (client) => {
    setSelectedClient(client);
    navigate(`/${encodeURIComponent(client.id)}`);
  };
  return (
    <Dropdown
      disabled={!shouldShowClientSelector}
      label="Select Client"
      items={clients}
      selected={selectedClient}
      onSelect={handleSelect}
      itemLabel={(c) => c.name}
      loading={loading}
    />
  );
}
